"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = function _default(config) {
  return {
    serviceName: 'retrieveFilter',
    authenticate: true,
    config: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      url: (0, _get.default)(config, 'endpoints.prompt.filters.filter.retrieve')
    }
  };
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/filters/retrieve-filter.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjb25maWciLCJzZXJ2aWNlTmFtZSIsImF1dGhlbnRpY2F0ZSIsIm1ldGhvZCIsImhlYWRlcnMiLCJBY2NlcHQiLCJ1cmwiLCJnZXQiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2VydmljZXMvc2VydmljZS1jb25maWdzL2ZpbHRlcnMvcmV0cmlldmUtZmlsdGVyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBnZXQgZnJvbSAnbG9kYXNoL2dldCc7XG5cbmV4cG9ydCBkZWZhdWx0IChjb25maWcpID0+ICh7XG5cdHNlcnZpY2VOYW1lOiAncmV0cmlldmVGaWx0ZXInLFxuXHRhdXRoZW50aWNhdGU6IHRydWUsXG5cdGNvbmZpZzoge1xuXHRcdG1ldGhvZDogJ0dFVCcsXG5cdFx0aGVhZGVyczoge1xuXHRcdFx0QWNjZXB0OiAnYXBwbGljYXRpb24vanNvbicsXG5cdFx0XHQnQ29udGVudC1UeXBlJzogJ2FwcGxpY2F0aW9uL2pzb24nLFxuXHRcdH0sXG5cdFx0dXJsOiBnZXQoY29uZmlnLCAnZW5kcG9pbnRzLnByb21wdC5maWx0ZXJzLmZpbHRlci5yZXRyaWV2ZScpLFxuXHR9LFxufSk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUE2QjtFQUFBO0VBQUE7QUFBQTtBQUFBO0VBQUE7QUFBQTtBQUFBLGVBRWQsa0JBQUNBLE1BQU07RUFBQSxPQUFNO0lBQzNCQyxXQUFXLEVBQUUsZ0JBQWdCO0lBQzdCQyxZQUFZLEVBQUUsSUFBSTtJQUNsQkYsTUFBTSxFQUFFO01BQ1BHLE1BQU0sRUFBRSxLQUFLO01BQ2JDLE9BQU8sRUFBRTtRQUNSQyxNQUFNLEVBQUUsa0JBQWtCO1FBQzFCLGNBQWMsRUFBRTtNQUNqQixDQUFDO01BQ0RDLEdBQUcsRUFBRSxJQUFBQyxZQUFHLEVBQUNQLE1BQU0sRUFBRSwwQ0FBMEM7SUFDNUQ7RUFDRCxDQUFDO0FBQUEsQ0FBQztBQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtJQUFBO0VBQUE7RUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7QUFBQSJ9